/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

class Footer extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="12">
          <div className="copyright text-center text-xl-center text-muted">
              © 2019{" "}
              <a
                className="font-weight-bold ml-1"
                href="#"
                rel="noopener noreferrer"
                target="_blank"
              >
                Paribesh App
              </a>
            </div>
          </Col>
        </Row>
      </footer>
    );
  }
}

export default Footer;
